import { App } from '~/app';

import { defineAsyncComponent } from 'vue';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Contextual Search Component');
    app.vueApp.component(
        'search-input',
        defineAsyncComponent(async () => import('./SearchInput.vue'))
    );
    app.vueApp.component(
        'search-results',
        defineAsyncComponent(async () => import('./SearchResults.vue'))
    );
    app.vueApp.component(
        'context-search-query',
        defineAsyncComponent(async () => import('./SearchQuery.vue'))
    );
    app.vueApp.component(
        'search-results-pagination',
        defineAsyncComponent(async () => import('./SearchResultsPagination.vue'))
    );
    app.vueApp.component(
        'search-filters',
        defineAsyncComponent(async () => import('./SearchFilters.vue'))
    );
    app.vueApp.component(
        'search-sort',
        defineAsyncComponent(async () => import('./SearchSort.vue'))
    );

    // Views
    // Cards
    app.vueApp.component(
        'card-view',
        defineAsyncComponent(async () => import('./card-views/CardView.vue'))
    );
    app.vueApp.component(
        'article-card-item',
        defineAsyncComponent(async () => import('./card-views/types/ArticleCardItem.vue'))
    );
    app.vueApp.component(
        'default--card-item',
        defineAsyncComponent(async () => import('./card-views/types/DefaultCardItem.vue'))
    );
    app.vueApp.component(
        'event-card-item',
        defineAsyncComponent(async () => import('./card-views/types/EventCardItem.vue'))
    );

    // Lists
    app.vueApp.component(
        'list-view',
        defineAsyncComponent(async () => import('./list-views/ListView.vue'))
    );
    app.vueApp.component(
        'article-list-item',
        defineAsyncComponent(async () => import('./list-views/types/ArticleListItem.vue'))
    );
    app.vueApp.component(
        'document-list-item',
        defineAsyncComponent(async () => import('./list-views/types/DocumentListItem.vue'))
    );
    app.vueApp.component(
        'default-list-item',
        defineAsyncComponent(async () => import('./list-views/types/DefaultListItem.vue'))
    );
};
